import { defineComponent as o, openBlock as r, createBlock as p, unref as l, mergeProps as s, withCtx as m, createElementVNode as t } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const v = /* @__PURE__ */ o({
  name: "IconExpressReplacement",
  __name: "IconExpressReplacement",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (i, e) => (r(), p(l(c), s(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        t("path", { d: "M12 6.75H3a.75.75 0 0 1 0-1.5h17.5a1.25 1.25 0 0 1 1.25 1.25v11a1.25 1.25 0 0 1-1.25 1.25h-14a1.25 1.25 0 0 1-1.25-1.25V12a.75.75 0 0 1 1.5 0v5.25h13.5V6.75H16v3.8a.3.3 0 0 1-.415.277l-1.47-.612a.3.3 0 0 0-.23 0l-1.47.612A.3.3 0 0 1 12 10.55v-3.8" }, null, -1),
        t("path", { d: "M3.25 9A.75.75 0 0 1 4 8.25h4a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 9" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
